<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav :to="$route.name === 'RenewPolicy' ? 'BranchSelectionReview' : 'BranchSelections'" />
      <top-card
          current="PaymentSelection"
          :cover-type="coverType"
          :instalments="installments"
          :premiumAmount = "premiumAmount"
          :loading="loading"
          @proceed="proceed(premiumAmount, 100)"
      >
        Full Payment
      </top-card>
      <template v-if="coverType.covertypeId === 120">
        <bima-bamba-installments
            v-if="coverType.productCode === 702"
            :cover-type="coverType"
            :installments="installments"
            :premium-amount="premiumAmount"
            @proceed="proceed"
        />
        <v-card v-else class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-5 md:tw-mt-10 tw-pb-5">
        <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
          Instalment Payment
          <hr class="tw-mt-4">
        </h3>
        <div class="tw-w-full tw-flex tw-flex-col">
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
                <p class="c-gray-text">First Instalment</p>
                <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">40%</h1>
                <p class="tw-w-full c-gray-text tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[0].premium | formatNum }}</h3>
                <v-btn color="secondary" class="tw-mt-2" large block :loading="loading1" @click="proceed(installments[0].premium, 40)">Confirm and Pay</v-btn>
              </div>
            </v-card>
          </div>
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
                <p class="c-gray-text">Second Instalment</p>
                <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">30%</h1>
                <p class="tw-w-full c-gray-text tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[1].premium | formatNum }}</h3>
                <h4 class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ addMonths(1) }}</h4>
              </div>
            </v-card>
          </div>
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
                <p class="c-gray-text">Third Instalment</p>
                <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">30%</h1>
                <p class="tw-w-full c-gray-text tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[2].premium | formatNum }}</h3>
                <h4 class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ addMonths(2) }}</h4>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
      </template>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import BackNav from '@/components/buy/BackNav';
import helpers from '@/utils/helpers';
import { addMonths } from '@/utils/time';
import { FB_BUY_FULL_PAYMENT, FB_BUY_INSTALMENT_PAYMENT } from '@/utils/const';
import axios from 'axios';
import BimaBambaInstallments from '@/components/buy/BimaBambaInstallments';
import TopCard from '@/components/buy/TopCard';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentSelection',
  props: {
    getQuote: Object,
    batchId: {
      required: false,
      default: null,
    },
  },
  components: { TopCard, BimaBambaInstallments, BackNav },
  data() {
    return {
      loading: false,
      loading1: false,
      pageLoading: false,
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    pageTitle() {
      if (this.coverType.covertypeId === 120) {
        return `${this.coverType.productCode === 702 ? 'Bima Bamba' : 'Comprehensive'}<br> Insurance Cover`;
      }
      return 'Third Party <br> Only';
    },
    coverType() {
      return this.$route.name === 'BuyCover' ? this.getQuote.covertypes.find((e) => e.riskId === parseInt(this.$route.query.b, 10)) : this.getQuote.covertypes.find((id) => id.selected === 'Y');
    },
    installments() {
      return this.getQuote.instalments;
    },
    premiumAmount() {
      return this.installments.reduce((sum, installment) => sum + installment.premium, 0);
    },
  },
  metaInfo: {
    title: 'Buy - Payment Selection',
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    proceed(amount, percentage) {
      const payment = {
        payableAmount: amount,
        kraPin: this.getQuote.client.kraPinNumber,
        accountReference: this.coverType.car.registrationNumber,
        description: this.batchId !== null ? `ren-${this.batchId}` : `rfq-${this.getQuote.quoteId}`,
        customerPhoneNumber: this.getQuote.client.mobileNumber,
      };
      const quoteInfo = {
        // eslint-disable-next-line no-nested-ternary
        coverType: this.coverType,
        payPercentage: percentage,
        client: this.getQuote.client,
        pageTitle: this.pageTitle,
      };

      const data = {
        premium: amount,
        quoteId: this.getQuote.quoteId,
        paymentType: percentage === 100 ? 'YEARLY' : 'MONTHLY',
      };
      axios.post('/customer/quotation/policy/update/policy-premium', data).then(() => {
        this.$analytics.logEvent(percentage === 100 ? FB_BUY_FULL_PAYMENT : FB_BUY_INSTALMENT_PAYMENT);
        this.$emit('to-make-payment', { data: { payment, quoteInfo } });
      });
    },
    addMonths,
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
